module.exports = __webpack_public_path__ + "static/media/my-lists-header.e9d612c1.jpg";